import { render, staticRenderFns } from "./GestioneStrutture.vue?vue&type=template&id=ce4e4f18&scoped=true&"
import script from "./GestioneStrutture.vue?vue&type=script&lang=js&"
export * from "./GestioneStrutture.vue?vue&type=script&lang=js&"
import style0 from "./GestioneStrutture.vue?vue&type=style&index=0&id=ce4e4f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4e4f18",
  null
  
)

export default component.exports